import {Injectable} from '@angular/core';

import {Platform} from 'ionic-angular';

/*
  Generated class for the SystemProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class SystemProvider {

  constructor(
    private platform: Platform
  ) {
    console.log('Hello SystemProvider Provider');
  }

  close() {
    if (this.platform.is('android')) {
      this.platform.exitApp();
    } else {
      window.location.reload(true);
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/system/system.ts